<script>
    import { Route, Router } from "svelte-navigator";
    import LocationsNew from "./_Locations/LocationsNew.svelte";
    import Network from "./_Networks/Network.svelte";
    import Networks from "./_Networks/Networks.svelte";
    import NetworksNew from "./_Networks/NetworksNew.svelte";
    import Organisation from "./_Organisations/Organisation.svelte";
    import Organisations from "./_Organisations/Organisations.svelte";
    import OrganisationsNew from "./_Organisations/OrganisationsNew.svelte";
    import User from "./_Users/User.svelte";
    import Users from "./_Users/Users.svelte";
    import UsersNew from "./_Users/UsersNew.svelte";
</script>

<Router>
    <Route path="networks">
        <Networks />
    </Route>

    <Route path="networks/new">
        <NetworksNew />
    </Route>

    <Route path="networks/:id" let:params>
        <Network id={params.id} />
    </Route>

    <Route path="locations/new/:networkId" let:params>
        <LocationsNew networkId={params.networkId} />
    </Route>

    <Route path="organisations">
        <Organisations />
    </Route>

    <Route path="organisations/new">
        <OrganisationsNew />
    </Route>

    <Route path="organisations/:id" let:params>
        <Organisation id={params.id} />
    </Route>

    <Route path="users">
        <Users />
    </Route>

    <Route path="users/new">
        <UsersNew />
    </Route>

    <Route path="users/:id" let:params>
        <User id={params.id} />
    </Route>
</Router>
